<template>
    <label for="menu-open" class="footer">
        <span class="add_fast">{{ $t('quick_access') }}</span>
    </label>
    <!-- <footer class="footer">
        <span>{{ currentYear }}</span> © by <a href="http://www.guco.com.br" target="_blank">Guco Agência Web</a>
    </footer> -->
</template>

<script>
    import moment from 'moment'

    export default {
        computed: {
            currentYear () {
                return moment().format('YYYY')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/root/Footer.vue